import { Types } from "../actions/BreakdownReasonDetailActions";

const initialState = {
    breakdownReasonDetails: {},
    plants: {},
    breakdownReasonGroups: {},
    breakdownReasonPlaces: {},
    isTaskUpdated: false,
};

export const BreakdownReasonDetailReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_BREAKDOWN_REASON_DETAILS:
            return {
                ...state,
                breakdownReasonDetails: action.payload ?? state.breakdownReasonDetails,
            };
        case Types.SET_PLANTS:
            return {
                ...state,
                plants: action.payload ?? state.plants,
            };
        case Types.SET_BREAKDOWN_REASON_GROUPS:
            return {
                ...state,
                breakdownReasonGroups: action.payload || state.breakdownReasonGroups,
            };
        case Types.SET_BREAKDOWN_REASON_PLACE_BY_ID:
            return {
                ...state,
                breakdownReasonPlaces: action.payload || state.breakdownReasonPlaces,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
